<nz-spin nzTip="Loading..." [nzSpinning]="bookingResource.isLoading()">
  <div class="flex flex-col gap-3 min-h-52">
    @if (bookings().length === 0) {
      <div class="text-center text-gray-500 py-8">ჯავშნები არ მოიძებნა</div>
    }

    @for (booking of bookings(); track booking.id) {
      <div class="border border-gray-200 px-4 py-3 rounded-md hover:bg-gray-50 transition-colors">
        <div class="flex justify-between items-center gap-4">
          <div class="flex flex-col gap-1 flex-1">
            <div class="text-sm font-medium">
              {{ booking.employee?.user?.fullName }}
            </div>
            <div class="flex items-center gap-1 text-xs text-gray-500">
              <i nz-icon nzType="field-time" nzTheme="outline" class="text-blue-500"></i>
              {{ booking.startTime }} - {{ booking.endTime }}
            </div>
            @for (bs of booking.bookingServices || []; track $index) {
              <div class="flex items-center gap-1 text-xs text-gray-600">
                <div
                  class="w-2 h-2 rounded-full"
                  [style.background-color]="bs?.service?.serviceCategory?.color || '#1890ff'"
                ></div>
                {{ bs?.service?.name }}
              </div>
            }
          </div>

          <button
            nz-button
            nzType="primary"
            nz-dropdown
            nzTrigger="click"
            [nzDropdownMenu]="ehrMenu"
          >
            EHR <i nz-icon nzType="down"></i>
          </button>
          <nz-dropdown-menu #ehrMenu="nzDropdownMenu">
            <ul nz-menu>
              @for (ehrType of ehrTypes; track ehrType.key) {
                <li nz-menu-item (click)="navigateToEhr(booking, ehrType.route)">
                  <i nz-icon [nzType]="ehrType.icon" class="mr-2"></i>
                  {{ ehrType.label }}
                </li>
              }
            </ul>
          </nz-dropdown-menu>
        </div>
      </div>
    }
  </div>
</nz-spin>
